import styled from 'styled-components';

export const ResultsWrapper = styled.div`
  padding-bottom: 16px;
`;

export const LoadingStep = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding: 0 20px;
  position: relative;

  @keyframes spinning {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .rotating {
    animation: 1500ms linear 0s spinning infinite;
    position: absolute;
    right: 20px;
    top: 0;
  }
`;
